import { apiGet, apiPost } from './apiAuth';

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const VALIDATION_API_BASE = `${API_BASE}/api`;

export async function getTasks() {
  try {
    const url = `${VALIDATION_API_BASE}/validation/tasks`;
    const response = await apiGet(url);
    return response.data;
  } catch (error) {
    console.error('Get tasks error:', error);
    throw error;
  }
}

export async function runValidation(taskId = null, projectId = null, containerId = null) {
  try {
    const body = {};
    if (projectId) {
      body.project_id = projectId;
    }
    if (containerId) {
      body.container_id = containerId;
    }
    
    const url = taskId 
      ? `${VALIDATION_API_BASE}/validation/run/${taskId}`
      : `${VALIDATION_API_BASE}/validation/run-all`;
    
    const response = await apiPost(url, body);
    return response.data;
  } catch (error) {
    console.error('Run validation error:', error);
    throw error;
  }
}

export async function getValidationStatus(jobId) {
  try {
    const url = `${VALIDATION_API_BASE}/validation/status/${jobId}`;
    const response = await apiGet(url);
    return response.data;
  } catch (error) {
    console.error('Get validation status error:', error);
    throw error;
  }
}

export async function getValidationResults(jobId) {
  try {
    const url = `${VALIDATION_API_BASE}/validation/results/${jobId}`;
    const response = await apiGet(url);
    return response.data;
  } catch (error) {
    console.error('Get validation results error:', error);
    throw error;
  }
}